export const SET_PANORAMA_UI_IS_VISIBLE = 'PanoActions.SET_PANORAMA_UI_IS_VISIBLE'
export const PANO_AUTOROTATE_STARTED = 'PanoActions.AUTOROTATE_STARTED'
export const PANO_AUTOROTATE_STOPPED = 'PanoActions.AUTOROTATE_STOPPED'
export const SET_PANO_START_LAT_LON = 'PanoActions.SET_PANO_START_LAT_LON'
export const SET_PANORAMA_BLURRED = 'PanoActions.SET_PANORAMA_BLURRED'
export const SET_CURRENT_XY = 'PanoActions.SET_CURRENT_XY'
export const PANORAMA_DRAG_START = 'PanoActions.DRAG_START'
export const PANORAMA_DRAG_END = '|A|PanoActions.DRAG_END'
export const DEVICEMOTION_START = 'PanoActions.DEVICEMOTION_START'
export const PANORAMA_TAP = '|A|PanoActions.TAP'
export const PANORAMA_MOUSE_WHEEL = 'PanoActions.PANORAMA_MOUSE_WHEEL'
export const SET_HOVERED_HOTSPOT_ID = 'PanoActions.SET_HOVERED_HOTSPOT_ID'
export const SET_FORCE_ROTATE = 'PanoActions.SET_FORCE_ROTATE'
export const CLEAR_FORCE_ROTATE = 'PanoActions.CLEAR_FORCE_ROTATE'
export const SET_DRAG_HINT_DETAILS = 'PanoActions.SET_DRAG_HINT_DETAILS'
export const REGISTER_PANO_PLAYER = 'PanoActions.REGISTER_PANO_PLAYER'
export const ENABLE_ACCELEROMETER_CONTROLS = 'PanoActions.ENABLE_ACCELEROMETER_CONTROLS'
export const SET_PANORAMA_SIZE = 'PanoActions.SET_PANORAMA_SIZE'
export const RESET_DEVICE_ORIENTATION_ALPHA_ANGLE = 'PanoActions.RESET_DEVICE_ORIENTATION_ALPHA_ANGLE'
export const SET_PANO_POSITION = 'PanoActions.SET_PANO_POSITION'
export const SET_CURSOR = 'PanoActions.SET_CURSOR'
export const REDRAW_PANORAMA_SCENE = 'PanoActions.REDRAW_PANORAMA_SCENE'

import { Map } from 'immutable'

export const setCursor = cursor => ({
    type: SET_CURSOR,
    cursor,
})

export const setPanoramaUIVisible = (visible = false) => ({
    type: SET_PANORAMA_UI_IS_VISIBLE,
    visible,
})

export const setCurrentXY = coords => {
    return (dispatch, getState) => {
        const currentXY = getState.getIn('panorama', 'currentXY')

        // Update current displacement if lat or lon has changed
        if (currentXY.lat !== coords.lat || currentXY.lat !== coords.lon) {
            dispatch({
                type: SET_CURRENT_XY,
                coords,
            })
        }
    }
}

export const setPanoStartLatLon = ({ lat, lon, isSetByTrigger = false }) => {
    return {
        type: SET_PANO_START_LAT_LON,
        values: {
            lat,
            lon,
            isSetByTrigger,
        },
    }
}

export const setPanoramaIsBlurred = ({ isPanoramaBlurred }) => ({
    type: SET_PANORAMA_BLURRED,
    isPanoramaBlurred,
})

export const setHoveredHotspotId = ({ id }) => {
    return {
        type: SET_HOVERED_HOTSPOT_ID,
        id,
    }
}

export const setForceRotate = ({ coords }) => {
    return {
        type: SET_FORCE_ROTATE,
        coords,
    }
}

export const clearForceRotate = () => {
    return (dispatch, getState) => {
        dispatch({
            type: CLEAR_FORCE_ROTATE,
        })
    }
}

export const panoAutoRotateStarted = () => ({
    type: PANO_AUTOROTATE_STARTED,
})

export const panoAutoRotateStopped = () => ({
    type: PANO_AUTOROTATE_STOPPED,
})

export const panoDragStarted = () => ({
    type: PANORAMA_DRAG_START,
})

export const panoDragStopped = () => ({
    type: PANORAMA_DRAG_END,
})

export const panoramaTapped = () => ({
    type: PANORAMA_TAP,
})

export const panoramaMouseWheel = () => ({
    type: PANORAMA_MOUSE_WHEEL,
})

export const setDragHintDetails = draggingHint => ({
    type: SET_DRAG_HINT_DETAILS,
    draggingHint: Map(draggingHint),
})

export const deviceMotionStart = _ => ({
    type: DEVICEMOTION_START,
})

export const registerPanoPlayer = panoPlayer => ({
    type: REGISTER_PANO_PLAYER,
    player: panoPlayer,
})

export const enableAccelerometerControls = enable => (dispatch, getState) => {
    const panoPlayer = getState().getIn(['panorama', 'player'])
    const { accelerometerControls } = (panoPlayer && panoPlayer.getOptions()) || {}

    // Only allow enabling/disabling of accelerometer if the option was true
    // upon instantiating
    if (accelerometerControls) {
        panoPlayer.enableAccelerometerControls(enable)
    }

    dispatch({
        type: ENABLE_ACCELEROMETER_CONTROLS,
        enable,
    })
}

export const setPanoramaSize = (width, height) => (dispatch, getState) => {
    const panoPlayer = getState().getIn(['panorama', 'player'])

    if (panoPlayer) {
        try {
            const { viewerHeight, viewerWidth } = panoPlayer.getSize()

            if (viewerWidth != width || height != viewerHeight) panoPlayer.setSize(width, height)
        } catch (error) {}
    }

    dispatch({
        type: SET_PANORAMA_SIZE,
    })
}

export const resetDeviceOrientationAlphaAngle = () => (dispatch, getState) => {
    const panoPlayer = getState().getIn(['panorama', 'player'])

    if (panoPlayer) {
        panoPlayer.resetDeviceOrientationAlphaAngle()
    }

    dispatch({
        type: RESET_DEVICE_ORIENTATION_ALPHA_ANGLE,
    })
}

export const setPosition = ({ lat, lon, speed }) => (dispatch, getState) => {
    const panoPlayer = getState().getIn(['panorama', 'player'])

    if (panoPlayer) {
        panoPlayer.setPosition({
            lat,
            lon,
            speed,
        })
    }

    dispatch({
        type: SET_PANO_POSITION,
    })
}

export const redrawPanoramaScene = () => (dispatch, getState) => {
    const panoPlayer = getState().getIn(['panorama', 'player'])

    if (panoPlayer) panoPlayer.setNeedsRefresh()

    dispatch({
        type: REDRAW_PANORAMA_SCENE,
    })
}
